import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteCondition, routeOutlets } from '@app/shared/enum/route';
import { ScheduleSelectors } from '@app/store/schedule/schedule.selectors';
import { SetRouteCondition } from '@app/store/setting/setting.classes';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteControlService {
  @Select(ScheduleSelectors.fetchHistory) reload$!: Observable<Date>;
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected store: Store
  ) { this.routeControlInit(); '' }

  routeControlInit() {
    this.router.events.subscribe(() => this.routeConfig());
  }

  routeConfig() {
    const activeRoute = this.getDeepestChild(this.route);
    const root = this.router.routerState.root;
    const editRoute = root.children.find(r => routeOutlets.some(outlet => outlet === r.outlet));
    let config: RouteCondition = RouteCondition.UNSET;
    if (editRoute) {
      config = editRoute?.snapshot?.data['routeCongfig'] || RouteCondition.UNSET;
    } else if (activeRoute.snapshot?.routeConfig?.data) {
      config = activeRoute.snapshot?.routeConfig?.data['routeCongfig'] || RouteCondition.UNSET;
    }
    this.store.dispatch(new SetRouteCondition(config));
  }

  getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  addSignature(signature: string) {
    return this.router.navigate([], {
      relativeTo: this.route,
      preserveFragment: true,
      // skipLocationChange: true,
      queryParamsHandling: 'merge',
      queryParams: { [signature]: true }
    });
  }

  removeAllSignature() {
    return this.router.navigate([], {
      queryParams: {},
      queryParamsHandling: '',
      preserveFragment: true
    });

  }
}
